import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const AccessDenied = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                    textAlign: 'center',
                }}
            >
                <ErrorOutlineIcon color="error" sx={{ fontSize: 100, mb: 2 }} />
                <Typography variant="h3" component="h1" gutterBottom color="text.primary">
                    Erişim Reddedildi
                </Typography>
                <Typography variant="h5" color="text.secondary" paragraph>
                    Bu sayfayı görüntülemek için yetkiniz bulunmamaktadır.
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Eğer bir hata olduğunu düşünüyorsanız lütfen sistem yöneticiniz ile iletişime geçin.
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/dashboard')}
                >
                    Ana Sayfaya Dön
                </Button>
            </Box>
        </Container>
    );
};

export default AccessDenied;
